/**
 * カスタム設定パネル
 */
export const CUSTOM_SETTING = {
  selectors: {
    trigger: '.js-custom-setting',
    overlay: '.c-setting__overlay',
  },

  classNames: {
    open: 'is-custom-open',
  },

  init() {
    const triggers = document.querySelectorAll(this.selectors.trigger)

    if (!triggers.length) {
      return
    }

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        document.body.classList.add(this.classNames.open)
      })
    })

    const overlays = document.querySelectorAll(this.selectors.overlay)

    overlays.forEach(overlay => {
      overlay.addEventListener('click', () => {
        document.body.classList.remove(this.classNames.open)
      })
    })
  },
}
